import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Container, Button } from "reactstrap";
import { useForm, FormProvider } from "react-hook-form";
import { DebounceInput } from "react-debounce-input";
import { CustomDatepicker } from "tvs-unified-lib";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useHistory } from "react-router";
import moment from "moment";

import GenericDropdownWithId from "components/form/GenericDropdownWithId";
import LoadingSpinner from "components/elements/loadingSpinner";
import Datepicker from "components/elements/Datepicker";
import { SelectGroupMappingDropdown } from "components/form/SelectGroupMappingDropdown";
import { SelectMultipleSalesAgent } from "components/form/SelectMultipleSalesAgent";

import { Localization, ROLE_NAME } from "constant";

import { interestLevelOptions } from "containers/LoanApplication/constant";

import {
	clearActionStatus,
	clearModel,
	fetchCollection,
} from "redux/crud/action";
import { State } from "redux/types";

import Colors from "themes/themeColors";

import { CUSTOMER_LIST_ITEM } from "types/customer";

import "./loanPage.css";
import CustomerData from "./CustomerData";
import LoanChartForMotorace from "./LoanChartForMotorace";
import LoanChartForWheeltek from "./LoanChartForWheeltek";
import LoanChartForNewNemar from "./LoanChartForNewNemar";
import { LoanSummary } from "./cardStatusDisplayConfig";
import LoanChartForCelestina from "./LoanChartForCelestina";

const LoanPage = () => {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const history = useHistory();
	const methods = useForm();
	const user: {
		id: number;
		branch_id: number;
		branch_name: string;
		role_name: string;
		locations: {
			list: any[];
		};
	} = JSON.parse(localStorage.getItem("tvsd.los.user"));

	const [isGroupMappingsDropdownOpen, setIsGroupMappingsDropdownOpen] =
		useState<boolean>(false);
	const [search, setSearch] = useState<string>("");
	const [dobselect, setDobSelect] = useState<any>(null);
	const [selectedAgents, setSelectedAgents] = useState<Array<number>>([]);
	const [agentList, setAgentList] = useState<
		Array<{ id: number; name: string }>
	>([]);
	const [isSelectAgentDropdownOpen, setIsSelectAgentDropdownOpen] =
		useState<boolean>(false);
	const [source, setSource] = useState<string>("");
	const [startDate, setStartDate] = useState<Date>(new Date());
	const [customerList, setCustomerList] = useState<Array<CUSTOMER_LIST_ITEM>>(
		[],
	);
	const [customerCount, setCustomerCount] = useState(0);
	const [perpage, setPerPage] = useState(0);
	const [loading, setLoading] = useState<boolean>(false);
	const [salesvalueGet, setSalesValueGet] = useState({
		page: 1,
		limit: 10,
		search: "",
	});
	const [loanSummary, setloanSummary] = useState<LoanSummary>({
		total_loan: 0,
		pending_submission: 0,
		resubmission: 0,
		under_verification: 0,
		credit_review: 0,
		pending_investigation: 0,
		pending_review: 0,
		under_evaluation: 0,
		manager_review: 0,
		approved: 0,
		rejected: 0,
		recalled: 0,
		withdrawn: 0,
		disbursed: 0,
	});
	const [isFirstRender, setIsFirstRender] = useState<boolean>(true);
	const [sourceStatus, setSourceStatus] = useState([]);
	const [summaryDisplay, setSummaryDisplay] = useState(true);
	const [interest, setInterest] = useState("");
	const [groupMappings, setGroupMappings] = useState<Array<any>>([]);
	const [allGroupMappings, setAllGroupMappings] = useState<Array<any>>([]);
	const [custGroupSelections, setCustGroupSelections] = useState<number[]>(
		user.role_name === ROLE_NAME.SALES_PERSON && user?.locations?.list?.length
			? user?.locations?.list.map((d) => d.group_id)
			: [],
	);
	const [loanGroupSelections, setLoanGroupSelections] = useState<number[]>(
		user?.locations?.list?.length
			? user?.locations?.list.map((d) => d.group_id)
			: [],
	);

	const agentMatchWithUser = agentList.find((d) => d.id === user.id);
	useEffect(() => {
		if (agentMatchWithUser && isFirstRender) {
			setSelectedAgents((prev) => [...new Set([...prev, agentMatchWithUser.id])]);
			setIsFirstRender(false);
		}
	}, [agentMatchWithUser]);

	const {
		register,
		setValue,
		clearErrors,
		getValues,
		control,
		formState: { errors },
	} = methods;
	const { crudState } = useSelector((st: State) => st);

	const searchHandler = (searchFromEventListener?: string) => {
		setPageNumber(1);
		const formattedMonth = moment(startDate).format("MM-yyyy");

		let state = {
			search: searchFromEventListener || search,
			groupIds:
				custGroupSelections.length > 0 ? JSON.stringify(custGroupSelections) : "",
			month: formattedMonth !== undefined ? formattedMonth : "",
			dateOfBirth: dobselect !== null ? dobselect : "",
			// agentId: typeof agent === "object" ? agent.id : "",
			agentIds: selectedAgents.length > 0 ? JSON.stringify(selectedAgents) : "",
			sourceId: source !== undefined ? source : "",
			interestLevelId: interest !== undefined ? interest : "",
		};

		dispatch(
			fetchCollection(
				"customerList",
				`/customer-creations?search=${state.search}&groupIds=${state.groupIds}&month=${state.month}&dateOfBirth=${state.dateOfBirth}&agentIds=${state.agentIds}&sourceId=${state.sourceId}&interestLevelId=${state.interestLevelId}&l=3&p=1`,
			),
		);
	};

	const handlePressKeyboardEnterButton = (e: any) => {
		if (e.key === "Enter") {
			if (loading) {
				return;
			}
			searchHandler(e.target.value);
		}
	};

	useEffect(() => {
		setTimeout(() => {
			dispatch(fetchCollection("notifications", "/notifications"));
		}, 3000);
	}, []);

	useEffect(() => {
		if (
			crudState?.groupMappings !== undefined &&
			crudState?.groupMappings?.collections?.pending === false
		) {
			setGroupMappings(crudState?.groupMappings?.collections?.payload?.data);
			setLoading(false);
		} else if (
			crudState?.groupMappings !== undefined &&
			crudState?.groupMappings?.collections?.pending === true
		) {
			setLoading(true);
		}
	}, [crudState?.groupMappings]);

	useEffect(() => {
		if (
			crudState?.allGroupMappings !== undefined &&
			crudState?.allGroupMappings?.collections?.pending === false
		) {
			setAllGroupMappings(crudState?.allGroupMappings?.collections?.payload?.data);
			setLoading(false);
		} else if (
			crudState?.allGroupMappings !== undefined &&
			crudState?.allGroupMappings?.collections?.pending === true
		) {
			setLoading(true);
		}
	}, [crudState?.allGroupMappings]);

	useEffect(() => {
		if (
			crudState?.customerList !== undefined &&
			crudState?.customerList?.collections?.pending === false
		) {
			if (
				crudState?.customerList?.collections?.payload?.data?.collections.length > 0
			) {
				setCustomerList(
					crudState?.customerList?.collections?.payload?.data?.collections,
				);
				setSummaryDisplay(false);
			} else if (
				crudState?.customerList?.collections?.payload?.data === undefined
			) {
				setSummaryDisplay(true);
			} else {
				setCustomerList([]);
				setSummaryDisplay(false);
			}

			setCustomerCount(crudState?.customerList?.collections?.payload?.data?.count);
			setPerPage(crudState?.customerList?.collections?.payload?.data?.perPage);
			setLoading(false);
		} else if (
			crudState?.customerList !== undefined &&
			crudState?.customerList?.collections?.pending === true
		) {
			setLoading(true);
		}
	}, [crudState?.customerList]);

	const [pageNumber, setPageNumber] = useState(1);
	const itemsPerPage = 3;

	useEffect(() => {
		setCustomerList([]);
		setSummaryDisplay(true);
		dispatch(
			fetchCollection(
				"agentList",
				`/sales-agent-list?search=${salesvalueGet.search}`,
			),
		);

		dispatch(fetchCollection("sourceList", "/loan-source-list"));
		dispatch(fetchCollection("groupMappings", "/groups/map"));
		dispatch(fetchCollection("allGroupMappings", "/groups-all/map"));
	}, []);

	useEffect(() => {
		if (loanGroupSelections.length > 0) {
			dispatch(
				fetchCollection(
					"loanSummary",
					`/loans-summary?groupIds=${JSON.stringify(loanGroupSelections)}`,
				),
			);
		}
	}, [loanGroupSelections]);

	useEffect(() => {
		if (
			crudState?.loanSummary !== undefined &&
			crudState?.loanSummary?.collections?.pending === false
		) {
			setloanSummary(crudState?.loanSummary?.collections?.payload?.data?.data);
			setLoading(false);
		} else if (
			crudState?.loanSummary !== undefined &&
			crudState?.loanSummary?.collections?.pending === true
		) {
			setLoading(true);
		} else if (
			crudState?.loanSummary === undefined ||
			crudState?.loanSummary === null
		) {
			setLoading(true);
		}
	}, [crudState?.loanSummary]);

	useEffect(() => {
		if (
			crudState?.sourceList !== undefined &&
			crudState?.sourceList?.collections?.pending === false
		) {
			setSourceStatus(crudState?.sourceList?.collections?.payload?.data);
			setLoading(false);
		} else if (
			crudState?.sourceList === undefined ||
			crudState?.sourceList?.collections?.pending === true
		) {
			setLoading(true);
		}
	}, [crudState?.sourceList]);

	useEffect(() => {
		dispatch(
			fetchCollection(
				"agentList",
				`/sales-agent-list?search=${salesvalueGet.search}`,
			),
		);
	}, [salesvalueGet]);

	useEffect(() => {
		if (
			crudState?.agentList !== undefined &&
			crudState?.agentList?.collections?.pending === false
		) {
			setAgentList(crudState?.agentList?.collections?.payload?.data);
			setLoading(false);
		} else if (
			crudState?.agentList !== undefined &&
			crudState?.agentList?.collections?.pending === true
		) {
			setLoading(true);
		}
	}, [crudState?.agentList]);

	const pageCount = Math.ceil(customerCount / itemsPerPage);

	const handlePageChange = ({ selected }) => {
		const day = dobselect?.getDate();
		const month = dobselect?.getMonth() + 1;
		const year = dobselect?.getFullYear();
		const formattedDate = `${day}/${month}/${year}`;
		const formattedYear = startDate?.getFullYear();
		let state = {
			search,
			groupIds:
				custGroupSelections.length > 0 ? JSON.stringify(custGroupSelections) : "",
			year: formattedYear !== undefined ? formattedYear : "",
			dateOfBirth: dobselect !== null ? formattedDate : "",
			// agentId: typeof agent === "object" ? agent : "",
			agentIds: selectedAgents.length > 0 ? JSON.stringify(selectedAgents) : "",
			sourceId: source !== undefined ? source : "",
			interestLevelId: interest !== undefined ? interest : "",
		};
		setPageNumber(selected + 1);
		dispatch(
			fetchCollection(
				"customerList",
				`/customer-creations?search=${state.search}&groupIds=${
					state.groupIds
				}&year=${state.year}&dateOfBirth=${state.dateOfBirth}&agentIds=${
					state.agentIds
				}&sourceId=${state.sourceId}&interestLevelId=${
					state.interestLevelId
				}&l=3&p=${selected + 1}`,
			),
		);
	};
	const isValidation = () => {
		if (
			search ||
			startDate ||
			dobselect ||
			selectedAgents.length > 0 ||
			source ||
			interest
		) {
			return true;
		} else {
			return false;
		}
	};

	const handleSearchAgent = (search: string) => {
		setSalesValueGet({
			...salesvalueGet,
			search,
		});
	};

	const clearHandler = () => {
		setSearch("");
		setStartDate(null);
		setDobSelect(null);
		setSource("");
		setInterest("");
		setSelectedAgents([]);
		setCustGroupSelections([]);
		dispatch(clearActionStatus("customerList"));
		dispatch(clearModel("customerList"));
	};

	const handleKeyPress = (event) => {
		if (event.key === "Enter") {
			event.preventDefault();
		}
	};
	useEffect(() => {
		const inputDate = getValues("date_of_birth");
		const dateString =
			inputDate.length > 0
				? new Date(inputDate).toLocaleDateString("en-IN")
				: null;
		setDobSelect(dateString);
	}, [getValues("date_of_birth")]);

	const getSummaryDisplay = () => {
		switch (true) {
			case Localization.isUsingNewNemarConfig:
				return (
					<LoanChartForNewNemar
						loanSummary={loanSummary}
						groupMappings={groupMappings}
						groupSelections={loanGroupSelections}
						setGroupSelections={setLoanGroupSelections}
					/>
				);
			case Localization.isUsingWheeltekConfig:
				return (
					<LoanChartForWheeltek
						loanSummary={loanSummary}
						groupMappings={groupMappings}
						groupSelections={loanGroupSelections}
						setGroupSelections={setLoanGroupSelections}
					/>
				);
			case Localization.isUsingCelestinaConfig:
				return (
					<LoanChartForCelestina
						loanSummary={loanSummary}
						groupSelections={custGroupSelections}
					/>
				);
			case Localization.isUsingMotoraceConfig:
				return (
					<LoanChartForMotorace
						loanSummary={loanSummary}
						groupSelections={custGroupSelections}
					/>
				);
		}
	};

	return (
		<>
			{/* <Breadcrumb
        data={[
          {
            label: t("Dashboard"),
            link: "/",
          },
          {
            label: t("Loans"),
            link: "/loans",
          },
        ]}
      /> */}
			<LoadingSpinner loading={loading} />
			<Container>
				<FormProvider {...methods}>
					<form>
						<Header>
							<Heading>{t("Loans")}</Heading>
							<WrapAction>
								<Button
									id="loan-page-create-new-customer-button"
									style={{
										backgroundColor: "white",
										borderRadius: "8px",
										width: "100%",
										height: "32px",
										padding: "0px",
										border: "1px solid #6956ba",
										margin: "0 16px 0 0",
										minWidth: "40px",
									}}
									onClick={() => {
										history.push("/new-customer"),
											dispatch(clearActionStatus("newCustomer"));
									}}>
									<ButtonAdd>
										<img
											src={`${process.env.PUBLIC_URL}/images/add-button.svg`}
											alt="refresh"
											width={24}
											height={24}
										/>
										<TextStyled style={{ color: Colors.White }}>
											{t("New Customers")}
										</TextStyled>
									</ButtonAdd>
								</Button>
							</WrapAction>
						</Header>
						<div
							style={{
								background: "#ffffff",
								paddingRight: "2%",
								borderRadius: "16px",
							}}>
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
									fontSize: "16px",
									fontWeight: "400",
								}}>
								<SearchWrapper
									style={{
										width: "48%",
										margin: "20px 0 20px 20px",
									}}>
									<DebounceInput
										id="loan-page-search-customer-text-input"
										minLength={3}
										debounceTimeout={1000}
										onFocus={() => {
											document
												.getElementById("loan-page-search-customer-text-input")
												.addEventListener("keypress", handlePressKeyboardEnterButton);
										}}
										onBlur={() => {
											document
												.getElementById("loan-page-search-customer-text-input")
												.removeEventListener("keypress", handlePressKeyboardEnterButton);
										}}
										onChange={(event) => {
											setSearch(event.target.value);
										}}
										onKeyPress={handleKeyPress}
										haveSearch={true}
										placeholder={t("Search By Customer ID, Name Or Mobile Number")}
										className="form-control"
										value={search || ""}
										style={{
											borderRadius: "8px",
											height: "56px",
											border:
												search.length > 0
													? `1px solid ${Colors.Primary}`
													: `1px solid ${Colors.Gray999}`,
											background: `${Colors.White}`,
											color: "#333333",
											"::placeholder": {
												color: "#999999", // Change to your desired color
											},
										}}
									/>
									{search.length >= 3 && (
										<Button
											onClick={() => setSearch("")}
											className="position-absolute circle-close border-none"
											style={{
												width: "20px",
												height: "20px",
												top: "39%",
												right: "1%",
												border: "none",
												backgroundColor: "transparent",
											}}
										/>
									)}
								</SearchWrapper>
								<SelectGroupMappingDropdown
									data={allGroupMappings}
									selections={custGroupSelections}
									setSelections={setCustGroupSelections}
									width="23%"
									isOpen={isGroupMappingsDropdownOpen}
									setIsOpen={setIsGroupMappingsDropdownOpen}
									direction="right"
								/>
								<DatePickerWrap
									id="customer-list-page-year-picker-toggle"
									style={{
										border: startDate
											? `1px solid ${Colors.Primary}`
											: `1px solid ${Colors.Gray999}`,
										}}>
										<CustomDatepicker
											value={startDate}
											onInputChange={(e) => {
												setStartDate(e);
											}}
											isRequired={false}
											format="MMMM yyyy"
											showMonthYearPicker={true}
										/>
								</DatePickerWrap>
							</div>
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
								}}>
								<DatePickerWrap
									id="loan-page-date-of-birth-picker-toggle"
									style={{
										margin: "0 0 0 20px",
										border: dobselect ? `1px solid ${Colors.Primary}` : "",
									}}>
									<Datepicker
										formLabel="DOB"
										placeholder="Search By Date Of Birth"
										name="date_of_birth"
										control={control}
										errors={errors}
										rules={{
											required: "Required!",
										}}
									/>
									<img
										src={`${process.env.PUBLIC_URL}/images/calendar_lines.svg`}
										alt="Calendar Outlined"
										width={20}
										height={20}
										style={{
											marginRight: "5px",
											marginLeft: "-25px",
											color: "#666666",
										}}
									/>
								</DatePickerWrap>
								<SelectMultipleSalesAgent
									data={agentList}
									selections={selectedAgents}
									setSelections={setSelectedAgents}
									width="23%"
									isOpen={isSelectAgentDropdownOpen}
									setIsOpen={setIsSelectAgentDropdownOpen}
									haveSearch={true}
									placeholderSearch="Search Sales Agent"
									handleSearch={handleSearchAgent}
								/>
								{/* <div
                  style={{
                    width: "23%",
                  }}
                >
                  <SelectObject
                    id="loan-page-sales-agent"
                    placeholderSearch="Search Sales Agent"
                    {...register("agent", {
                      required: "Select Agent",
                    })}
                    handleChange={(item: string) => {
                      setAgent(item);
                      setValue("agent", item);
                      clearErrors("agent");
                    }}
                    handleItem={(title: string) => {
                      handleItem(title);
                    }}
                    haveSearch={true}
                    handleSearch={handleSearchAgent}
                    handleScroll={(e) => onScroll(e)}
                    list={agentList}
                    selection={agent}
                    value={agent}
                    title="Sales Agent"
                    width="100%"
                    defaultOption=""
                  />
                  <TextError message={errors?.agent?.message} />
                </div> */}
								<DropdownContainer style={{ width: "23%" }}>
									<GenericDropdownWithId
										id="loan-page-source"
										handleChange={(item: string) => {
											setValue("sourceStatus", item);
											clearErrors("sourceStatus");
											setSource(item);
										}}
										list={sourceStatus}
										selection={source}
										{...register("sourceStatus", {
											required: "Select source status",
										})}
										value={source}
										title="Status"
										width="100%"
										isMuti={false}
									/>
								</DropdownContainer>
								<DropdownContainer style={{ width: "23%" }}>
									<GenericDropdownWithId
										id="loan-page-interest"
										handleChange={(item: string) => {
											setValue("interestLevel", item);
											setInterest(item);
										}}
										list={interestLevelOptions}
										selection={interest}
										value={interest}
										title="Interest Level"
										width="100%"
										isMuti={false}
										haveIcon={true}
									/>
								</DropdownContainer>
							</div>
							<hr style={{ background: "#B1B6FF", margin: "2% 0% 2% 1%" }} />
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
									padding: "16px 0px 16px 0px",
								}}>
								<SpanTxt></SpanTxt>
								<div className="d-flex justify-content-end align-items-center ">
									<BaseButton
										id="loan-page-clear-all-filter-button"
										style={styleButtonReset}
										variant="contained"
										onClick={clearHandler}>
										Clear All
									</BaseButton>
									<BaseButton
										id="loan-page-search-button"
										style={{
											styleButtonSave,
											background: !isValidation() ? "#E7E9ED" : "#6956BA",
											border: !isValidation() && "none",
											color: !isValidation() ? `${Colors.Gray999}` : "#FFFFFF",
										}}
										disabled={!isValidation()}
										variant="contained"
										onClick={() => searchHandler()}>
										Search
									</BaseButton>
								</div>
							</div>
						</div>

						{summaryDisplay ? (
							getSummaryDisplay()
						) : customerList?.length === 0 ? (
							<div style={{ marginTop: "2%" }}>
								<CustomerCount>{customerCount} customers found</CustomerCount>
								<CustomerNotFoundContainer>
									<img
										src={`${process.env.PUBLIC_URL}/images/icon-search.svg`}
										alt="search-icon"
									/>
									<CustomerNotFoundMainText>No fesult found</CustomerNotFoundMainText>
									<CustomerNotFoundSecondaryText>
										Try again by adjusting your filter and keywords
									</CustomerNotFoundSecondaryText>
								</CustomerNotFoundContainer>
							</div>
						) : (
							customerList?.length > 0 && (
								<div style={{ marginTop: "2%" }}>
									<CustomerCount>{customerCount} customers found</CustomerCount>
									{customerList?.map((item, idx) => (
										<CustomerData
											key={idx.toString()}
											setLoading={setLoading}
											data={item}
										/>
									))}
									<BottomContainer>
										<PaginationInfoText>
											Showing item{" "}
											{pageNumber === 1 ? pageNumber : (pageNumber - 1) * 3 + 1}-
											{(pageNumber - 1) * 3 + perpage} out of {customerCount} items
										</PaginationInfoText>
										<ReactPaginate
											previousLabel={<ArrowBackIcon style={{ color: "#3548c9" }} />}
											nextLabel={<ArrowForwardIcon style={{ color: "#3548c9" }} />}
											breakLabel={"..."}
											pageCount={pageCount}
											marginPagesDisplayed={1}
											pageRangeDisplayed={3}
											onPageChange={handlePageChange}
											containerClassName={"pagination"}
											activeClassName={"active"}
											forcePage={pageNumber - 1}
										/>
									</BottomContainer>
								</div>
							)
						)}
					</form>
				</FormProvider>
			</Container>
		</>
	);
};

const CustomerNotFoundContainer = styled.div`
	margin-top: 8px;
	min-height: 198px;
	width: 100%;
	border-radius: 16px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background: #ffffff;
`;

const CustomerNotFoundMainText = styled.div`
	font-family: Inter;
	line-height: 22px;
	font-weight: 700;
	font-size: 16px;
	text-align: center;
	margin: 5px auto;
	color: #74849c;
`;

const CustomerNotFoundSecondaryText = styled.div`
	font-family: Inter;
	font-size: 14px;
	line-height: 19px;
	text-align: center;
	margin: 5px auto;
	color: #74849c;
`;

const Heading = styled.div`
	font-size: 36px;
	padding-top: 24px;
	font-style: normal;
	font-weight: 700;
	line-height: 48px;
	padding-bottom: 24px;
	color: #333333;
`;

const CustomerCount = styled.div`
	font-family: Inter;
	font-weight: 700;
	font-size: 14px;
	color: #253858;
	line-height: 19px;
`;

const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const WrapAction = styled.div`
	display: flex;
	align-items: center;
`;

const TextStyled = styled.span`
	font-size: 14px;
	line-height: 22px;
	font-weight: 700;
	text-align: center;
	color: ${Colors.Primary};
`;

const ButtonAdd = styled(Button)`
	&& {
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: ${Colors.Primary};
		border-radius: 8px;
		width: fit-content;
		height: 32px;
		font-size: 14px;
		border-color: ${Colors.Primary};
		text-transform: capitalize;
		:hover {
			opacity: none;
			background-color: ${Colors.Primary};
		}
	}
`;

const SearchWrapper = styled.div`
	position: relative;
	font-size: 16px;
	font-weight: 400;
	line-height: 22px;
	letter-spacing: 0em;
	text-align: left;
	color: #333333;
	&:before {
		background: url(${process.env.PUBLIC_URL}/images/search.png) no-repeat center
			left;
		content: "";
		display: block;
		clear: both;
		width: 20px;
		height: 20px;
		position: absolute;
		top: 14px;
		left: 10px;
	}
	input::placeholder {
		color: ${Colors.Gray999};
	}
	input.form-control {
		padding-left: 40px;
	}
`;

const DatePickerWrap = styled.div`
	border: 1px solid rgb(153, 153, 153);
	height: 56px;
	border-radius: 8px;
	background: #fff;
	width: 23%;
	// margin: 20px;
	padding: 1rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
	.react-datepicker {
		border-color: ${Colors.Primary} !important;
		box-shadow: 0px 0px 5px 0px #33333333 !important;
		margin-top: 0.9%;
	}
	.react-datepicker__header {
		background-color: #dde0ff !important;
	}
	.react-datepicker__current-month {
		color: ${Colors.Primary} !important;
	}
	.react-datepicker__navigation--previous {
		border-right-color: ${Colors.Primary};
	}
	.react-datepicker__navigation--next {
		border-left-color: ${Colors.Primary};
	}
	.react-datepicker__day--selected,
	.react-datepicker__day--keyboard-selected {
		background-color: transparent !important;
		border-radius: 1000px !important;
		border: 1px solid ${Colors.Primary} !important;
		color: #333 !important;
	}
	.react-datepicker__triangle {
		opacity: 0;
	}

	input {
		border: none;
		width: 100%;
		cursor: pointer;
		background-color: transparent;
	}
	input[type="text"]:focus-visible {
		border: none;
		outline: none;
	}
`;

const DropdownContainer = styled.div`
	.dropdown-item {
		display: flex !important;
		justify-content: space-between !important;
		align-items: center !important;
		white-space: nowrap !important;
		color: #333333;
		&::placeholder {
			color: #999999;
		}
	}
`;

const BaseButton = styled(Button).attrs(({ id }) => ({
	id,
}))`
	min-width: 130px !important;
	min-height: 35px !important;
	width: 130px;
	height: 35px;
	border-radius: 8px !important;
	margin-bottom: 1% !important;
`;

const styleButtonSave = {
	minWidth: "16% !impotant",
	minHeight: "1.5rem !impotant",
	width: "15% !impotant",
	height: "2.5rem    !impotant",
	marginRight: "2%",
	padding: "5px",
};

const styleButtonReset = {
	padding: "5px",
	minWidth: "16% !impotant",
	minHeight: "1.5rem !impotant",
	width: "15% !impotant",
	height: "2.5rem !impotant",
	background: "#FFFFFF",
	fontWeight: "700",
	color: "#6956BA",
	border: "1px solid #6956BA",
	marginRight: "7%",
};

const SpanTxt = styled.span`
	font-size: 16px;
	font-weight: 700;
	line-height: 22px;
	text-align: center;
	color: #6956ba;
	padding-left: 1%;
`;

const BottomContainer = styled.div`
	margin: 30px 0;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
`;

const PaginationInfoText = styled.div`
	font-family: Inter;
	line-height: 16px;
	font-size: 12px;
	color: #566a89;
`;

export default LoanPage;
